import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";

import Landing from "./pages/Landing";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Routines from "./pages/Routines";
import DIY from "./pages/DIY";
import Dupes from "./pages/Dupes";
import Challenges from "./pages/Challenges";
import Progress from "./pages/Progress";
import Insights from "./pages/Insights";
import Library from "./pages/Library";
import Premium from "./pages/Premium";
import Profile from "./pages/Profile";
import { Terms, Privacy, Refund, Contact } from "./pages/LegalPages";

// If already authed and onboarded, redirect away from public marketing pages.
function PublicGuard({ children }) {
  const { user, profile, loading } = useAuth();
  if (loading) return null;
  if (user && profile?.onboarding_complete) return <Navigate to="/app" replace />;
  if (user && profile && !profile.onboarding_complete) return <Navigate to="/onboarding" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<PublicGuard><Landing /></PublicGuard>} />
              <Route path="/signup" element={<PublicGuard><Signup /></PublicGuard>} />
              <Route path="/login" element={<PublicGuard><Login /></PublicGuard>} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/refund" element={<Refund />} />
              <Route path="/contact" element={<Contact />} />
              <Route
                path="/onboarding"
                element={
                  <ProtectedRoute requireOnboarding={false}>
                    <Onboarding />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <AppShell />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="routines" element={<Routines />} />
                <Route path="diy" element={<DIY />} />
                <Route path="dupes" element={<Dupes />} />
                <Route path="challenges" element={<Challenges />} />
                <Route path="progress" element={<Progress />} />
                <Route path="insights" element={<Insights />} />
                <Route path="library" element={<Library />} />
                <Route path="premium" element={<Premium />} />
                <Route path="profile" element={<Profile />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AnimatePresence>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
